
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { User } from '../../lib/models/User'

import RallyRegisterPhoneNumber from './RallyRegisterPhoneNumber.vue'
import RallyRegisterTShirtSize from './RallyRegisterTShirtSize.vue'

@Component({
  components: {
    RallyRegisterPhoneNumber,
    RallyRegisterTShirtSize
  }
})
export default class RallyRegisterOtherData extends Vue {
  @Prop({ required: true }) user!: User

  get customerReferrerTypes () {
    return User.customerReferrerTypes
  }
}
